import React from 'react'
import useWindowSize from '../../util/useWindowSize';
import Confetti from 'react-confetti'

export default () => {
  const { width, height } = useWindowSize()
  return (
    <Confetti
      width={width}
      height={height}
      numberOfPieces={100}
      recycle={false}
    />
  )
}
